ChangeBoardPermsView = require 'app/scripts/views/board-menu/change-board-perms-view'

module.exports = class ChangeBoardAddMemberPermsView extends ChangeBoardPermsView
  viewTitleKey: 'add member permissions'
  getTemplate: -> require('app/scripts/views/templates/board_menu_invitations')
  getPerm: -> 'invitations'
